<template>
    <pulse-loader sm=12 class="text-center experto-retail-loader"
                  :color="color"/>
</template>
<script>
  export default {
    name: 'ExpertoRetailLoader',
    props: {
      color: {
        type: String,
        default: () => { return '#290A99' }
      }
    }
  }
</script>
<style scoped>
  .experto-retail-loader {
    margin-top: 45vh
  }
</style>



// WEBPACK FOOTER //
// src/expertoRetail/atoms/ExpertoRetailLoader.vue